var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Icon } from '../icon/icon.js';
import { NoStyleButton } from '../../no-style-button.js';
import { cva } from 'class-variance-authority';
import { cn } from '../../cn.js';
import { styledBackwardsCompatibility } from '../../styled-backwards-compatibility.js';
const badgeVariants = cva('caption1-emphasized inline-flex justify-center items-center whitespace-nowrap h-300 min-w-300 gap-50 rounded-100', {
    variants: {
        variant: {
            default: 'bg-surfaceDim text-onSurface',
            standard: 'bg-surfaceContainerHigh text-onSurfaceVariant border border-solid border-outlineVariant',
            prime: 'bg-prime text-onPrime',
            primary: 'bg-primary text-onPrimary',
            primaryContainer: 'bg-primaryContainer text-onPrimaryDim',
            plain: 'text-onSurface',
            plainPrimary: 'text-primary',
            super: 'bg-superContainer text-onSuperContainer',
            success: 'bg-successContainer text-onSuccessContainer',
            warn: 'bg-warnContainer text-onWarnContainer',
            error: 'bg-errorContainer text-onErrorContainer',
            info: 'bg-infoContainer text-onInfoContainer',
        },
        letterOnly: {
            true: 'headline px-75',
        },
        density: {
            tight: 'px-50 h-250',
            loose: 'px-100',
        },
    },
    defaultVariants: {
        variant: 'default',
        density: 'loose',
    },
});
export const Badge = styledBackwardsCompatibility(forwardRef((_a, ref) => {
    var { variant, className, letterOnly, density } = _a, props = __rest(_a, ["variant", "className", "letterOnly", "density"]);
    const Component = props.onClick ? NoStyleButton : 'div';
    return _jsx(Component, Object.assign({ ref: ref }, props, { className: cn(badgeVariants({ variant, letterOnly, density, className })) }));
}));
export const BadgeIcon = (props) => _jsx(Icon, Object.assign({ size: "small" }, props));
export const BadgeWithIcon = styledBackwardsCompatibility(forwardRef((_a, ref) => {
    var { children, leadIcon } = _a, props = __rest(_a, ["children", "leadIcon"]);
    return (_jsxs(Badge, Object.assign({ ref: ref }, props, { children: [leadIcon && _jsx(BadgeIcon, { name: leadIcon }), children] })));
}));
//# sourceMappingURL=badge.js.map